export const ModalEvents = {
  OPEN: "OPEN",
  CLOSE: 'CLOSE'
};